module.exports = __webpack_public_path__ + "static/media/msk-doctors.9382930d.png";